import { T } from '@agos/shared'
import { NotFoundScreen } from '@agos/ui'

/**
 * The router's fallback. It belongs to no feature — every module's unmatched path lands here — so the
 * shell owns it. The markup is `@agos/ui`'s, shared with the CMS page's own miss (legacy carries it
 * twice).
 */
export function NotFoundPage() {
  return (
    <NotFoundScreen
      heading={<T>Stránka nebola nájdená</T>}
      explanation={<T>Je nám ľúto, ale stránka ktorú hľadáte neexistuje.</T>}
      homeLabel={<T>Späť na menu</T>}
    />
  )
}
